export type UploadedFile = {
  enableDelete: boolean
  fileName: string
  id: number
  uploadedDate: string
}
